import angular from 'angular';

import catalogService from '../../services/catalog.service';
import databaseService from '../../services/database.service';

import kbSearchController from './kbSearch.controller.js';

export default angular.module('components.kbsearch', [catalogService, databaseService])
    .component('kbSearch', {
        template: require('./kbSearch.pug')(),
        bindings: {
            facetsList: '<',
            rsnList: '<',
            schemasList: '<',
            onNext: '&'
        },
        controller: kbSearchController
    })
    .component('kbSearch2', {
        template: require('./kbSearch2.pug')(),
        bindings: {
            facetsList: '<',
            rsnList: '<',
            attributesList: '<',
            materialsList: '<',
            sortKeysList: '<',
            schemasList: '<'
        },
        controller: kbSearchController
    })
    .component('kbDocumentsList', {
        bindings: {
            catalogid: '@',
            content: '<'
        },
        template: require('./kbDocumentsList.pug')()
    })
    .component('kbDocumentsListItem', {
        bindings: {
            catalogid: '@',
            item: '<'
        },
        template: require('./kbDocumentsListItem.pug')()
    })
    .component('kbGetRecordById', {
        bindings: {
            catalogid: '@',
            docid: '<',
            schema: '@',
            mode: '@'
        },
        template: '<display-record mode="{{$ctrl.mode}}" schema="{{$ctrl.schema}}" content="$ctrl.response.records[0].recordData"></display-record>',
        controller: [ 'CatalogService', function(CatalogService) {
            var ctrl = this;

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    ctrl.load();
                }
            };
 
            ctrl.load = function() {
                var self = this;
                var params = {};

                ctrl.response = null;
                ctrl.error = null;

                params.id = ctrl.catalogid;
                params.command = 'search';
                params.type= 'CQL'
                params.query = 'rec.id="' + ctrl.docid.replace(/\\/g, '\\\\')+ '"';
                params.recordSchema = ctrl.schema;
                CatalogService.get(params).$promise.then(function(response) {
                    self.response = response.data;
                }, function(err) {
                    self.error = err.message || err;
                    console.log(self.error);
                });
            };

       }]
    })
    .component('kbFacet', {
        bindings: {
            facetspec: '<',
            querystr: '<',
            catalogid: '@',
            onSelect: '&'
        },
        template: require('./kbFacet.pug')(),
        controller: ['KBSearchConfig', 'CatalogService', function(KBSearchConfig, CatalogService) {
            var ctrl = this;

            ctrl.$onInit = function() {
            };

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    if (changes.querystr) {
                        ctrl.querystr = changes.querystr.currentValue;
                        load();
                    }
                }
            };

            ctrl.selectItem = function(item) {
                item.facetspec = ctrl.facetspec;
                ctrl.onSelect({item: item});
            };

            ctrl.isActive = function(querystr, index, item) {
                var apt = index + ' "' + item.DATA + '"';
                if (querystr) { 
                    return querystr.includes(apt);
                } else {
                    return false;
                }
            };

            ////////
            
            function load() {
                var qs  = {
                    id: ctrl.catalogid,
                    command: 'search',
                    type: 'CQL',
                    query: ctrl.querystr,
                    recordSchema: ctrl.facetspec.schema,
                    maximumRecords: 1
                };

                console.log('load kb-facet', ctrl.facetspec);

                CatalogService.get(qs).$promise.then(function(response) {
                    ctrl.response = response.data; 
                }, function(err) {
                    console.log(err.message || err);
                });
            }

        }]
    })
    .component('kbFacetItem', {
        template: require('./kbFacetItem.pug')(),
        bindings: {
            active: '@',
            item: '<',
            onSelect: '&'
        },
        controller: function() {
            var ctrl = this;

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    if (changes.item) {
                        ctrl.item = changes.item.currentValue;
                    }
                }
            };

            ctrl.select = function() {
                ctrl.onSelect({item: ctrl.item});
            };
        }
    })
    .component('kbDocument', {
        bindings: {
            catalogid: '@',
            docid: '<'
        },
        template: require('./kbDocument.pug')(),
        controller: ['$state', 'CatalogService', 'KBSearchConfig', function($state, CatalogService, KBSearchConfig) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.schemasList = KBSearchConfig.schemasList;
                ctrl.callSearch();
            };

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    if (changes.docid) {
                        ctrl.docid = changes.docid.currentValue;
                    }
                }
            };

            ctrl.callSearch = function() {
                var docid =  ctrl.docid.replace(/"/g, '\\"').replace(/\\/g, '\\\\');
                var query = 'rec.id="' + docid + '"';
                var schema = ctrl.schemasList[0].value;

                ctrl.loading = true;
                search(ctrl.catalogid, query, schema, function(err, response) {
                    ctrl.loading = false;
                    if (err) {
                        ctrl.error = err.message || err;
                    }
                    ctrl.response = response.data;
                });
            };

            ////////

            function search(id, q, schema, done) {
                var params = {};
                params.id = id;
                params.command = 'search';
                params.type = 'CQL';
                params.query = q;
                params.recordSchema = schema;
                console.log(params);
                CatalogService.get(params).$promise.then(function(response) {
                    done(null, response);
                }, function(err) {
                    done(err, null);
                });
            }
        }]
    })
    .value('KBSearchConfig', {
        facetsList: [
            {name: __("Author"), index: 'dc.creator', schema: 'zebra::facet::author:p:10'},
            {name: __("Subject heading"), index: 'dc.subject', schema: 'zebra::facet::subject-heading:p:10'},
            {name: __("Publisher"), index:'dc.publisher', schema: 'zebra::facet::publisher:p:10'},
            {name: __("Publication date"), index: 'dc.date', schema: 'zebra::facet::date-of-publication:w:10'},
        ],
        rsnList: [
            //{name: __("Year of publication"), index: 'dc.date', query: 'cuba.dateNarrow=2021', schema: 'marcxml'},
            //{name: __("eHolding collection"),  index: 'cuba.project_tpu_987m', query: 'cuba.project_tpu_987m_Facet=z', schema: 'marcxml'}
            //{name: __("Author"), query: 'cuba.authorNarrow=а', schema: 'FIXME!'},
            //{name: __("Subject heading"),  query: 'cuba.subjectNarrow=а', schema: 'FIXME!'}
        ],
        upperBound: 1000,
        maxSize: 10,
        hitsList: [
            {name: "1", value: 1},
            {name: "5", value: 5},
            {name: "10", value: 10},
            {name: "20", value: 20},
            {name: "50", value: 50}
        ],
        schemasList: [
            {name: __("BIB"), value: "bib"}, 
            {name: __("BIB v1.1"), value: "bibv1.1"}, 
            {name: __("Portal"), value: "portal"}, 
            {name: __("MARC"), value: "marcxml"} 
        ],
        sortKeysList: [
            {name: __('Relevant'), value:''},
            {name: __('Publication date (new)'), value:'cql.sortByDateDescending=0'},
            {name: __('Publication date (old)'), value:'cql.sortByDateAscending=0'},
            {name: __('Author (A-Z)'), value:'cql.sortByAuthorAscending=0', glyphicon: 'glyphicon glyphicon-sort-by-alphabe'},
            {name: __('Author (Z-A)'), value:'cql.sortByAuthorDescending=0', grlyphicon: 'glyphicon glyphicon-sort-by-alphabet-alt'},
            {name: __('Record key (ascending)'), value:'cql.sortByLocalNumberAscending=0'},
            {name: __('Record key (descending)'), value:'cql.sortByLocalNumberDescending=0'},
        ],
        relationsList: [
            {name: __('exactly'), value: '='},
            {name: __('any'), value: 'any'},
            {name: __('all'), value: 'all'}
        ],
        attributesList: [
            {name: __('Title'), value: 'dc.title'},
            {name: __('Author'), value: 'dc.creator'},
            {name: __('Discipline'), value: 'dc.subject'},
            {name: __('ISBN'), value: 'bath.isbn'},
            {name: __('ISSN'), value: 'bath.issn'},
            {name: __('Year of publication'), value: 'dc.date'},
            {name: __('Geographic location'), value: 'cuba.placePublication'},
            {name: __('Publisher'), value: 'dc.publisher'},
            {name: __('All fields'), value: 'cql.serverChoice'},
            {name: __('Universal Decimal Classification'), value: 'cuba.classificationUDC'},
            {name: __('Library-Bibliographical Classification'), value: 'cuba.classificationLocal'},
            {name: __('OKSVNK Classification'), value: 'cuba.classificationLocal'},
            {name: __('Record insertion date'), value: 'cuba.dateAddedToDB'},
            {name: __('Record identifier'), value: 'rec.id'},
            //{name: __('Все записи?'), value: 'cql.allRecords'},
            {name: __('Exhibition name'), value: 'cql.cuba.exhibition'},
            {name: __('Exhibition identifier'), value: 'cql.cuba.exhibitionCode'},
            {name: __('Discipline name'), value: 'cql.cuba.discipline'}
        ],
        materialsList: [
            {name:__("All content types"), value:""},
            /*
            {name:"Монографические", value:"cuba.bibLevel=m"},
            {name:"Аналитические", value:"cuba.bibLevel=a"},
            {name:"Подборки", value:"cuba.bibLevel=c"},
            {name:"Интегрируемые ресурсы", value:"cuba.bibLevel=i"},
            */
            {name:__("Books"), value:"(cuba.bibLevel=m and (cuba.recordType=a or cuba.recordType=b))"},
            {name:__("Journals [by name]"), value:"(cuba.bibLevel=s and (cuba.recordLinking=1 or cuba.recordLinking=0))"},
            {name:__("Journals [issues, volumes]"), value:"(cuba.bibLevel=s and cuba.recordLinking=2)"},
            {name:__("Abstract Journals"), value:"(cuba.bibLevel=s and dc.format=d)"},
            {name:"Articles", value:"cuba.bibLevel=a"},
            {name:"Video Recordings", value:"cuba.recordType=g"},
            {name:"Audio Recordings", value:"(cuba.recordType=i or cuba.recordType=j)"},
            {name:"Electronic Resources", value:"cuba.recordType=l"},
            {name:"Bibliographic publications", value:"dc.format=a"},
            {name:"Dissertations/Thesis", value:"(dc.format=m or dc.format=d)"},
            {name:"Government Documents", value:"((cuba.bibLevel=s and dc.format=l) or (cuba.bibLevel=m and dc.format=n))"},
            {name:"Maps", value:"(cuba.recordType=e or cuba.recordType=f)"},
            {name:"Sheet Music", value:"(cuba.recordType=c or cuba.recordType=d)"},
            {name:"Technical Reports", value:"dc.format=p"},
            {name:"Patents", value:"(cuba.bibLevel=m and dc.format=k)"},
            {name:"Industrial Catalogs", value:"dc.format=b"},
            {name:"Dictionaries", value:"dc.format=e"},
            {name:"Reference Books", value:"dc.format=g"},
            {name:"Standards", value:"(cuba.bibLevel=m and dc.format=l)"},
            {name:"Tutorials", value:"dc.format=j"},
            {name:"Encyclopedias", value:"dc.format=f"}
        ],
        locationsList: [
            {name:__("Все фонды"), value:""},
            {name:__("научно-методический отдел"), value:"НМО"},
            {name:__("научный фонд"), value:"НФ"},
            {name:__("редкий фонд"), value:"РФ"},
            {name:__("учебный фонд"), value:"УФ"},
            {name:"художественный фонд", value:"ХФ"},
            {name:"читальный зал гуманитарной литературы", value:"ЧЗГЛ"},
            {name:"читальный зал справочно-библиографических изданий", value:"ЧЗСБИ"},
            {name:"читальный зал иностранной литературы", value:"ЧЗИЛ"},
            {name:"читальный зал периодических изданий", value:"ЧЗПИ"},
            {name:"читальный зал курсового и дипломного проектирования", value:"ЧЗКДП"},
            {name:"читальный зал технической литературы", value:"ЧЗТЛ"},
            {name:"читальный зал электронных ресурсов", value:"ЧЗЭР"},
            {name:"кафедра методики преподавания иностранных языков", value:"ЯЦ_МПИЯ"},
            {name:"кафедра иностранного языка ИСГТ", value:"ЯЦ_ИСГТ"},
            {name:"кафедра иностранного языка ИПР", value:"ЯЦ_ИПР"},
            {name:"кафедра иностранного языка ИФВТ", value:"ЯЦ_ИФВТ"},
            {name:"кафедра иностранного языка ИНК", value:"ЯЦ_ИНК"},
            {name:"кафедра иностранного языка ЭНИН", value:"ЯЦ_ЭНИН"},
            {name:"кафедра иностранного языка ФТИ", value:"ЯЦ_ФТИ"},
            {name:"подготовительное отделение ИМОЯК", value:"ЯЦ_ИМОЯК_ПО"},
            {name:"языковой центр ИМОЯК, к. 312 корпус 19", value:"ЯЦ_ИМОЯК1"},
            {name:"языковой центр ИМОЯК, к. 423 корпус 19", value:"ЯЦ_ИМОЯК2"},
            {name:"языковой центр ИМОЯК, к. 518 корпус 19", value:"ЯЦ_ИМОЯК3"},
            {name:"языковой центр \"Медиатека\" ИСГТ", value:"ЯЦ_Медиатека"},
            {name:"кафедра иностранного языка ИК, корпус 10", value:"ЯЦ_ИК1"},
            {name:"кафедра иностранного языка ИК", value:"ЯЦ_ИК"},
            {name:"ресурсный центр языковой подготовки", value:"ЯЦ_РЦЯП"}
        ],
        languagesList: [
            {name:"Все языки", value:""},
            {name:"Английский", value:"eng"},
            {name:"Русский", value:"rus"},
            {name:"-- Список в алфавитном порядке --", value:""},
            {name:"Абазинский", value:"aba"},
            {name:"Абхазский", value:"abk"},
            {name:"Авадхи", value:"awa"},
            {name:"Аварский", value:"ava"},
            {name:"Авестийский", value:"ave"},
            {name:"Австралийские языки", value:"aus"},
            {name:"Австронезийские (другие)", value:"map"},
            {name:"Адангме", value:"ada"},
            {name:"Адыгейский", value:"ady"},
            {name:"Азербайджанский", value:"aze"},
            {name:"Аймара", value:"aym"},
            {name:"Айну", value:"ain"},
            {name:"Акан", value:"aka"},
            {name:"Аккадский", value:"akk"},
            {name:"Албанский", value:"alb"},
            {name:"Алгонкинские языки", value:"alg"},
            {name:"Алеутский", value:"ale"},
            {name:"-- Аллеманский см. Швейцарский немецкий --", value:""},
            {name:"Алтайские (другие)", value:"tut"},
            {name:"-- Амаринья см. Амхарский --", value:""},
            {name:"Амхарский", value:"amh"},
            {name:"Ангика", value:"anp"},
            {name:"Английский", value:"eng"},
            {name:"Англо-креольские и пиджины (другие)", value:"cpe"},
            {name:"Апачские языки", value:"apa"},
            {name:"Арабский", value:"ara"},
            {name:"Аравакский", value:"arw"},
            {name:"Арагонский", value:"arg"},
            {name:"Арамейский", value:"arc"},
            {name:"Арапахо", value:"arp"},
            {name:"Армянский", value:"arm"},
            {name:"Аромунский", value:"rup"},
            {name:"-- Арумынский см. Аромунский --", value:""},
            {name:"Ассамский", value:"asm"},
            {name:"Астурийский", value:"ast"},
            {name:"Атапачские языки", value:"ath"},
            {name:"Афар", value:"aar"},
            {name:"Афразийские (другие)", value:"afa"},
            {name:"Африкаанс", value:"afr"},
            {name:"Африхили (искусственный язык)", value:"afh"},
            {name:"Ахвахский", value:"akh"},
            {name:"Ацтекские языки", value:"nah"},
            {name:"Ачехский", value:"ace"},
            {name:"Ачоли", value:"ach"}
        ],
        maximumTerms: 50 
    })
    .filter('ogTitle', [function() {
        return function(input) {
            var content = null ;
            // bib v1.0
            if (input['bib:record']['bib:domain1']) {
                content = input['bib:record']['bib:domain1'][0];
            }

            //bib v1.1
            if (input['bib:record']['bib:level0']) {
                content = input['bib:record']['bib:level0'][0]['bib:domain1'][0];
            }
            if (input['bib:record']['bib:level1']) {
                content = input['bib:record']['bib:level1'][0]['bib:domain1'][0];
                if (input['bib:record']['bib:level2']) {
                    content = content + '. ' + input['bib:record']['bib:level2'][0]['bib:domain1'][0];
                }
            }
            if (input['bib:record']['bib:domain-authorities-header']) {
                content = input['bib:record']['bib:domain-authorities-header'][0];
            }
            return content;
        }
    }])
    .filter('ogDescription', [function() {
        return function(input) {
            var content = null;
            if (input['bib:record']['bib:referat']) {
                content = input['bib:record']['bib:referat'][0];
            }
            if (content === null) {
                if (input['bib:record']['bib:level0']) {
                    content = input['bib:record']['bib:level0'][0]['bib:domain1'][0];
                }
                if (input['bib:record']['bib:level1']) {
                    content = input['bib:record']['bib:level1'][0]['bib:domain1'][0];
                    if (input['bib:record']['bib:level2']) {
                        content = content + '. ' + input['bib:record']['bib:level2'][0]['bib:domain1'][0];
                    }
                }
                if (input['bib:record']['bib:domain-authorities-header']) {
                    content = input['bib:record']['bib:domain-authorities-header'][0];
                }
            }
            return content;
        }
    }])
    .filter('ogKeywords', [function() {
        return function(input) {
            var content = null;
            if (input['bib:record']['bib:subjects']) {
                content = input['bib:record']['bib:subjects'].join('; ');
            }
            if (content === null) {
                if (input['bib:record']['bib:level0']) {
                    content = input['bib:record']['bib:level0'][0]['bib:domain1'][0];
                }
                if (input['bib:record']['bib:level1']) {
                    content = input['bib:record']['bib:level1'][0]['bib:domain1'][0];
                    if (input['bib:record']['bib:level2']) {
                        content = content + '. ' + input['bib:record']['bib:level2'][0]['bib:domain1'][0];
                    }
                }
                if (input['bib:record']['bib:domain-authorities-header']) {
                    content = input['bib:record']['bib:domain-authorities-header'][0];
                }
            }
            return content;
        }
    }])
    .name;
